<template>
  <component
    :is="tag"
    ref="container"
    @click="$emit('ob-click', $event)"
    @mouseenter="$emit('hover', $event)"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    getRef: {
      type: Function,
      default: () => false
    },
    ratio: {
      type: Number,
      default: 0
    },
    once: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: false,
      count: 0
    }
  },
  watch: {
    isVisible(val) {
      this.count++
      if (this.once && this.count > 1) {
        return
      }
      this.$emit(val ? 'show' : 'hide')
      this.$emit('visible', val)
    }
  },
  mounted() {
    const ref = this.getRef() || this.$refs.container
    this.observerHandler = this.$observer(ref, ([entry]) => {
      this.isVisible = entry.intersectionRatio > this.ratio
    })
  }
}
</script>
